import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setSelectedPackage, reportDWH, reportAnalytics } from '../PremiumPackagesCatalogSlice';
import PackageBoxList from '../Partials/packageBoxList/packageBoxList';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import likeIcon from '../images/icon-like.svg';
const AllPackagesInstalledPage = (props) => {

    useExtendedEffect((runSideEffects) => {
        props.reportAnalytics({
            eventCategory: 'premium_packages',
            eventAction: 'visibility_17',
            eventLabel: 'element_19'
        });
        if (runSideEffects()) {
        }
    }, []);

    let purpleTitle = "";
    let boldTitle1 = "";
    let boldTitle2 = "";
    let extraBoldTitle = "ואו! יש לכם את כל החבילות שלנו";

    let formid = 'premiumPackagesCatalogForm';

    let currentPageHeadline = (
        <div className='page-headline-wrapper'>
            <div className='icon like' style={{backgroundImage: likeIcon.bg()}}></div>
            {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
            {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
            {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
            {extraBoldTitle && <h3 className='extra-bold-title'> {extraBoldTitle} </h3>}
        </div>

    );

    let currentPageView = (<>
        <PackageBoxList defaultImage={props.defaultImage} selectedTab={props.selectedTab} installedPackages={props.installedPackages} onClickPackage={handleOnClickPackage} />
        <BtnWhiteBlackBorderBigSize text={'חזרה לאזור האישי'} onclick={() => onClickBtn()} />
    </>);

    return (
        <div>
            {currentPageHeadline}
            <div className='premium-packages-catalog-content'>
                <form noValidate id={formid} onSubmit={handleSubmit}>
                    {currentPageView}
                </form>
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }

    function handleOnClickPackage(premiumPackage) {
        props.setSelectedPackage(premiumPackage);
        props.goToPage('packageExistPage');
    }

    function onClickBtn() {
        //TODO: GO TO LOBBY PAGE
    }

};

const mapStateToProps = (state) => {
    return {
        selectedTab: state.premiumPackagesCatalog.selectedTab,
        installedPackages: state.premiumPackagesCatalog.installedPackages,
        defaultImage: state.premiumPackagesCatalog.epiData?.defaultImage,
    };
};

const mapDispatchToProps = {
    setSelectedPackage,
    goToPage,
    reportAnalytics
};

export default connect(mapStateToProps, mapDispatchToProps)(AllPackagesInstalledPage);